import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// services
import { OpportunityViewService } from '@app/opportunities/services/opportunity-view.service';

@Injectable()
export class OpportunityViewGuardService implements CanActivate {
  constructor(
    private opportunityViewService: OpportunityViewService,
    private router: Router
  ) {}

  public canActivate(
    activeSnapshot: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> {
    // opportunity will be undefined here *only* if the call for it returned a 404
    // which might be due to the opportunity not existing, but might also be due to
    // the user not having permission to view it (private, etc)
    return this.opportunityViewService
      .canAccessOpportunity(activeSnapshot.paramMap.get('id'))
      .pipe(
        map((access) =>
          // TODO: Update this once career/opportunities falls back, or if it gets
          // moved to `/opportunities`.
          access ? true : this.router.parseUrl('/career/opportunities/browse')
        )
      );
  }
}
